/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


/**
 * Represents the type of a rollout action.
 */
export type RolloutActionType = 'TASK' | 'NOTIFICATION';

export const RolloutActionType = {

    TASK: 'TASK' as RolloutActionType,

    NOTIFICATION: 'NOTIFICATION' as RolloutActionType
};

